import Link from 'next/link';
import { Avatar } from '../Avatar/Avatar';
import { PublisherInfoProps } from './types';

import { c } from '../../utils/tailwind-merge';
import { CertifiedPublisher } from '../CertifiedPublisher/CertifiedPublisher';

export const PublisherInfo = ({
  publisherName,
  publisherLink,
  showAvatar,
  isCertified,
  microcopy,
  size = 'medium',
  publisherAvatarUrl,
  className = '',
}: PublisherInfoProps) => {
  const avatarSize = size === 'big' ? 44 : 24;

  const textClass = size === 'small' ? 'text-xs' : 'text-sm';

  const avatarProps = {
    userName: publisherName,
    userProfilePicture: publisherAvatarUrl,
    size: avatarSize,
    className: 'bg-grey-900',
  };

  return (
    <div className={c('flex items-center', className)}>
      {showAvatar &&
        (publisherLink ? (
          <Link href={publisherLink} aria-label={publisherName}>
            <Avatar {...avatarProps} />
          </Link>
        ) : (
          <Avatar {...avatarProps} />
        ))}
      {publisherLink ? (
        <Link
          href={publisherLink}
          className={c(
            'flex items-center leading-5 text-grey-900',
            textClass,
            showAvatar ? 'pl-2' : '',
            isCertified ? 'pr-1' : ''
          )}
        >
          {publisherName}
        </Link>
      ) : (
        <span
          className={c(
            'flex items-center leading-5 text-grey-900',
            textClass,
            showAvatar ? 'pl-2' : '',
            isCertified ? 'pr-1' : ''
          )}
        >
          {publisherName}
        </span>
      )}
      {isCertified && (
        <CertifiedPublisher microcopy={microcopy.certifiedPublisher} />
      )}
    </div>
  );
};
